/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Text as DefText } from './Text';
import { Title } from './Title';

const AccountRemovementEmailConfirm = () => {
  const { t } = useTranslation();

  return (
    <>
      <Title>{t('ACCOUNT_REMOVEMENT_EMAIL_CONFIRM__title')}</Title>
      <Text>{t('ACCOUNT_REMOVEMENT_EMAIL_CONFIRM__desc')}</Text>
    </>
  );
};

const Text = styled(DefText)`
  margin-left: 0;
  margin-right: 0;
`;

export { AccountRemovementEmailConfirm };
